
import Vue from "vue";
import { mapGetters, mapState, mapActions } from "vuex";
import { IRootState } from "@/store/types";
import { routes, ROUTE_NAMES } from "@/routes";
import { AUTH } from "@/store/auth";
import { BASE_URL } from "@/helpers/config";

export default Vue.extend({
  data: () => ({
    dialog: false,
    drawer: null,
    publicPath: BASE_URL
  }),
  methods: {
    isActive(item: any) {
      const currentRoute = this.$route;
      return (
        currentRoute.path === item.path ||
        currentRoute.name === item.name ||
        (currentRoute.meta.parentName &&
          currentRoute.meta.parentName === item.name)
      );
    },
    ...mapActions({
      signOut: AUTH.NS(AUTH.ACTIONS.LOGOUT)
    })
  },
  computed: {
    routeParentName() {
      return this.$route.meta.parentName;
    },
    items(): any[] {
      const roles = (this as any).roles;
      return (
        routes
          // filter out routes that do not have meta.display is set
          .filter(route => route.meta && route.meta.display)
          .map(route => ({
            text: route.meta && route.meta.display,
            name: route.name,
            path: route.path,
            roles: route.meta && route.meta.requireRole
          }))
          // filter out routes base on the users role
          .filter(
            route =>
              !route.roles ||
              (roles &&
                route.roles.some((role: string) => roles.indexOf(role) >= 0))
          )
      );
    },
    ...mapState({
      roles: (state: IRootState) => state.auth.roles,
      isAuthenticated: (state: IRootState) => state.auth.isAuthenticated
    }),
    ...mapGetters({
      username: AUTH.NS(AUTH.GETTERS.GET_USERNAME)
    })
  }
});
